export default "__VITE_ASSET__BcZCwKfB__"